export class Notifier {
    show(message: string): void {
        console.log('default validation notifier', message);
    }
}
